var MAX_RTT = 700;
/**
 * This plugin is bound with BrowserConfigManager, so it can't be extract into @sdk/web
 */
export var TimeCalibrationPlugin = function (client) {
    var startTime;
    var hasCalibrated = false;
    client.on('init', function () {
        startTime = new Date().getTime();
        client.on('config', function () {
            var _a;
            var serverTime = (_a = client.config()) === null || _a === void 0 ? void 0 : _a.serverTimestamp;
            if (isNaN(serverTime) || Number(serverTime) <= 0 || hasCalibrated) {
                return;
            }
            hasCalibrated = true;
            var endTime = new Date().getTime();
            var potential_rtt = endTime - startTime;
            if (potential_rtt < MAX_RTT && serverTime) {
                var diff = serverTime - (endTime + startTime) / 2;
                !isNaN(diff) && client.set({ offset: diff });
            }
        });
    });
};
//# sourceMappingURL=time-calibration.js.map